<template>
  <v-card>
    <v-card-title>
      <!-- <v-flex xs6>
          <cal-picker data-vv-scope="filterForm" :label="filtersLabel.effDate" v-model="filters.effDate"></cal-picker>
        </v-flex> -->
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="filters.search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.discLdgDesc }}</td>
        <td class="text-xs-left">{{ props.item.defDiscLdgPct }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" remove review @review="doReview" @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click.native="doNew()">New Discount / Loading<v-icon>mdi-plus</v-icon></v-btn>
    <v-dialog v-model="discLdgDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Discount Loading for Product</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="!newDiscLdg">
                <v-subheader class="queryLabel">{{labels.discLdgQuery}}</v-subheader>
                <div class="title">{{labels.discLdgDesc}}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete :label="labels.discLdg" v-model="discLdgForm.discLdg" :items="discLdgList" item-text="label" item-value="value" :error-messages="errors.first('product') ? errors.first('product') : errors.collect('discLdg')" data-vv-name="discLdg" :data-vv-as="labels.discLdg" v-validate="'required'" :loading="discLdgLoading"></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-num-mask="{negative: true, intScale: 5, decScale: 2}" :label="labels.defDiscLdgPct" v-model="discLdgForm.defDiscLdgPct" :error-messages="errors.collect('defDiscLdgPct')" v-validate="'required'" data-vv-name="defDiscLdgPct" :data-vv-as="labels.defDiscLdgPct"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Discount Loading?
      <div class="title">{{deleteProductDiscLdg}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import { removeFormatNumber, formatDisplayNumber } from '@/utils/number.js'
import { extractMenu } from '@/utils/extract'
export default {
  data() {
    return {
      headers: [
        { text: 'Discount / Loading', value: 'discLdgDesc' },
        { text: 'Default Discount / Loading Percentage', value: 'defDiscLdgPct' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortBy: 'defDiscLdgPct'
      },
      filters: {
        discLdg: null
      },
      filtersLabel: {
        discLdg: 'Discount Loading'
      },
      labels: {
        discLdgQuery: 'Discount Loading',
        discLdgDesc: null,
        discLdg: 'Discount Loading*',
        defDiscLdgPct: 'Default Discount Loading Percentage*'
      },
      discLdgForm: {
        product: null,
        discLdg: null,
        defDiscLdgPct: null
      },
      loading: false,
      discLdgList: [],
      discLdgLoading: false,
      discLdgDialog: false,
      deleteProductDiscLdg: '',
      promptRemove: false,
      newDiscLdg: false
    }
  },
  computed: {
    productMenu() {
      return this.$store.state.productManagement.product.menu
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.productManagement.product.init !== 1) {
        await this.$store.dispatch('productMenuInit', this.product)
      }
      this.discLdgForm.product = this.product
      await this.fetchData(this.product)
      await this.getDiscLdgList()
    },
    async fetchData(xproduct) {
      this.loading = true
      const apiURI = this.productMenu.discLdgProducts
      if (apiURI) {
        try {
          const expand = {
            product: xproduct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((productDiscLdg) => {
              const convertList = {
                product: productDiscLdg.product,
                discLdg: productDiscLdg.discLdg,
                discLdgDesc: productDiscLdg.discLdgDesc,
                defDiscLdgPct: formatDisplayNumber(productDiscLdg.defDiscLdgPct)
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            this.loading = false
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Product Discount / Loading')
        this.loading = false
      }
    },
    async doReview(item) {
      this.newDiscLdg = false
      const apiURI = this.productMenu.discLdgProduct
      if (apiURI) {
        try {
          const expand = {
            appID: this.appID,
            product: item.item.product,
            discLdg: item.item.discLdg
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.discLdgForm.product = data.productDiscLdg.product
            this.discLdgForm.discLdg = data.productDiscLdg.discLdg
            this.labels.discLdgDesc = data.productDiscLdg.discLdgDesc
            if (data.productDiscLdg.defDiscLdgPct !== null) {
              this.discLdgForm.defDiscLdgPct = formatDisplayNumber(data.productDiscLdg.defDiscLdgPct)
            }
            this.discLdgDialog = true
            this.menu = extractMenu(result.data._links)
          } else {
            this.$snotify.error('Invalid Data - Product Discount / Loading Review')
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Discount / Loading Review')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newDiscLdg) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.discLdgProductUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const formatForm = {
            product: this.discLdgForm.product,
            discLdg: this.discLdgForm.discLdg,
            defDiscLdgPct: removeFormatNumber(this.discLdgForm.defDiscLdgPct)
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.discLdgForm.product)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Discount / Loading Update')
      }
    },
    async doCreate() {
      const apiURI = this.productMenu.discLdgProductCreate
      if (apiURI) {
        this.submitting = true
        try {
          const formatForm = {
            product: this.discLdgForm.product,
            discLdg: this.discLdgForm.discLdg,
            defDiscLdgPct: removeFormatNumber(this.discLdgForm.defDiscLdgPct)
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.discLdgForm.product)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Product Discount / Loading Create')
      }
    },
    doClose() {
      this.resetMessages()
      this.newDiscLdg = false
      this.discLdgForm.discLdg = undefined
      this.discLdgForm.defDiscLdgPct = undefined
      this.discLdgDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProductDiscLdg = data
        this.deleteProductDiscLdg = data.discLdgDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.productManagement.product.menu.discLdgProductDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          discLdg: this.selectedProductDiscLdg.discLdg,
          product: this.product,
          defDiscLdgPct: removeFormatNumber(this.selectedProductDiscLdg.defDiscLdgPct)
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Product Discount Loading')
      }
    },
    async doNew() {
      this.resetMessages()
      this.discLdgForm.discLdg = undefined
      this.discLdgForm.defDiscLdgPct = undefined
      this.newDiscLdg = true
      this.discLdgDialog = true
      await this.getDiscLdgList()
    },
    async getDiscLdgList() {
      const apiURI = this.productMenu.discLdgList
      if (apiURI) {
        try {
          this.discLdgLoading = true
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.discLdgList = data
          }
          this.discLdgLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Product Discount / Loading List')
      }
    }
  },
  created() {
    if (this.product === 'new') {
      this.newProduct = true
    } else {
      Promise.all([this.doInit()])
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
